import { VEBYearlyOpenAndCurrentEffectiveDate } from "../../constants/VEBYearlyOpenAndCurrentDate";
import calculateAge, {
	// calculateAgeDynamic,
	calculateAgeDynamicV2
} from "./age";
import { dateTimeZoneConverter } from "./date";
import { dollarize } from "./dollarize";
import initCapitalize from "./initCapitalize";

// export const handleDateCellRenderer = ({ value }: { value: string | boolean }): JSX.Element => {
// 	return <div>{value ? dateTimeZoneConverter(value as any) : value === false ? "" : "N/A"}</div>;
// };

export const handleDateCellRenderer = ({ value }: { value: string | null | false | undefined }): JSX.Element => {
	if (value === false || value === undefined || value === "CURRENT" || value === "FUTURE") {
		return <></>;
	}
	if (value?.length === 0) {
		return <>N/A</>;
	}
	return <div>{value ? (dateTimeZoneConverter(value) as string) : "N/A"}</div>;
};

export const handleDollarCellRenderer = ({ value }: { value: number }): JSX.Element => {
	return <div>{dollarize(value)}</div>;
};

// export const handleAgeCellRenderer = ({ value }: { value: string }) => {
// 	return (
// 		<div>
// 			{calculateAgeDynamicV2(value, VEBYearlyOpenAndCurrentEffectiveDate.veb_yearly_open_effective_date_YYYYMMDD)}
// 		</div>
// 	);
// };
export const handleAgeCellRenderer = (params: any) => {
	const value = params.value;

	const {
		data: { VEBPlanName }
	} = params;

	if (!value) return null;

	const isVEB = VEBPlanName ? true : false;

	return (
		<div>
			{isVEB
				? calculateAgeDynamicV2(
						value,
						VEBYearlyOpenAndCurrentEffectiveDate.veb_yearly_open_effective_date_YYYYMMDD
				  )
				: calculateAge(value, new Date())}
		</div>
	);
};

export const handleCapitalizeCellRenderer = ({ value }: { value: string }) => {
	const capitalize = initCapitalize(value);
	return <div>{capitalize}</div>;
};

export const handleValueCellRenderer = ({ value }: { value: string }) => {
	return <div>{value ? value : "N/A"}</div>;
};
